export default "__VITE_ASSET__C$mGI9eK__"